import { defineComponent as S, computed as s, openBlock as C, createElementBlock as M, normalizeStyle as F, normalizeClass as y, createElementVNode as H, renderSlot as N, createCommentVNode as w } from "vue";
const D = {
  key: 0,
  class: "banner__gradient"
}, l = "center center", O = /* @__PURE__ */ S({
  __name: "LandingBannerComponent",
  props: {
    bannerHeight: {
      default: "mid"
    },
    bannerPosition: {
      default: () => ({
        xs: l,
        sm: ""
      })
    },
    contentPosition: {
      default: () => ({
        xs: l,
        sm: ""
      })
    },
    backgroundColor: {
      default: ""
    },
    hasNoBackground: {
      type: Boolean,
      default: !1
    },
    bannerGradient: {
      default: () => ({})
    },
    bannerGradientMode: {
      default: ""
    }
  },
  setup(V, {
    expose: E
  }) {
    const a = V, h = {
      thin: {
        xs: "400px",
        "xs-plus": "400px",
        sm: "384px",
        md: "496px",
        lg: "616px"
      },
      short: {
        xs: "448px",
        "xs-plus": "448px",
        sm: "432px",
        md: "558px",
        lg: "693px"
      },
      mid: {
        xs: "540px",
        "xs-plus": "540px",
        sm: "512px",
        md: "662px",
        lg: "821px"
      },
      tall: {
        xs: "600px",
        "xs-plus": "600px",
        sm: "576px",
        md: "744px",
        lg: "924px"
      }
    }, v = {
      thin: {
        xs: 1.6,
        "xs-plus": 1.6,
        "ratio-denominator": 20
      },
      short: {
        xs: 1.6,
        "xs-plus": 1.6,
        "ratio-denominator": 16
      },
      mid: {
        xs: 1.6,
        "xs-plus": 1.6,
        "ratio-denominator": 12
      },
      tall: {
        xs: 1.6,
        "xs-plus": 1.6,
        "ratio-denominator": 10
      }
    }, m = (e) => {
      let t = "", n = "";
      if (!e) return "";
      const r = e.split(" "), [i, o] = r;
      return i === "left" ? t = "flex-start" : i === "right" ? t = "flex-end" : i === "center" && (t = "center"), o === "top" ? n = "flex-start" : o === "bottom" ? n = "flex-end" : o === "center" && (n = "center"), {
        horizontal: t || "",
        vertical: n || ""
      };
    }, x = (e, t) => {
      let n = "";
      const o = t === "Dark" ? {
        base: "#000000",
        target: "rgba(0, 0, 0, 0)"
      } : {
        base: "#FFFFFF",
        target: "rgba(255, 255, 255, 0)"
      };
      switch (e) {
        case "to bottom":
          n = `linear-gradient(to bottom, ${o.base} -3.78%, ${o.target} 87.39%)`;
          break;
        case "to top":
          n = `linear-gradient(to top, ${o.base} -3.78%, ${o.target} 87.39%)`;
          break;
        case "to left":
          n = `linear-gradient(to left, ${o.base} -3.78%, ${o.target} 87.39%)`;
          break;
        case "to right":
          n = `linear-gradient(to right, ${o.base} -3.78%, ${o.target} 87.39%)`;
          break;
        default:
          n = "";
      }
      return n;
    }, p = s(() => {
      var n, r;
      const e = ((n = a.bannerGradient) == null ? void 0 : n.xs) && x(a.bannerGradient.xs, a.bannerGradientMode) || "none", t = ((r = a.bannerGradient) == null ? void 0 : r.sm) && x(a.bannerGradient.sm, a.bannerGradientMode) || e;
      return {
        xs: e,
        sm: t
      };
    }), b = s(() => v[a.bannerHeight] || v.mid), c = s(() => h[a.bannerHeight] || h.mid), u = s(() => {
      const {
        xs: e,
        sm: t,
        md: n,
        lg: r
      } = a.bannerPosition || {};
      return {
        xs: e || l,
        sm: t || e || l,
        md: n || t || e || l,
        lg: r || n || t || e || l
      };
    }), d = s(() => {
      var n, r;
      const e = ((n = a.contentPosition) == null ? void 0 : n.xs) && m(a.contentPosition.xs) || m(l), t = ((r = a.contentPosition) == null ? void 0 : r.sm) && m(a.contentPosition.sm) || e;
      return {
        xs: e,
        sm: t
      };
    }), f = s(() => {
      var e, t, n, r, i, o, _, z, P, $, B, G;
      return {
        "--banner-height-xs": (e = c.value) == null ? void 0 : e.xs,
        "--banner-height-xs-plus": (t = c.value) == null ? void 0 : t["xs-plus"],
        "--banner-height-sm": (n = c.value) == null ? void 0 : n.sm,
        "--banner-height-md": (r = c.value) == null ? void 0 : r.md,
        "--banner-height-lg": (i = c.value) == null ? void 0 : i.lg,
        "--banner-position-xs": (o = u.value) == null ? void 0 : o.xs,
        "--banner-position-sm": (_ = u.value) == null ? void 0 : _.sm,
        "--banner-position-md": (z = u.value) == null ? void 0 : z.md,
        "--banner-position-lg": (P = u.value) == null ? void 0 : P.lg,
        "--block-vertical-position-xs": d.value.xs.vertical,
        "--block-vertical-position-sm": d.value.sm.vertical,
        "--block-horizontal-position-xs": d.value.xs.horizontal,
        "--block-horizontal-position-sm": d.value.sm.horizontal,
        "--banner-gradient-xs": p.value.xs,
        "--banner-gradient-sm": p.value.sm,
        "--padding-xs": `${($ = b.value) == null ? void 0 : $.xs}rem`,
        "--padding-xs-plus": `${(B = b.value) == null ? void 0 : B["xs-plus"]}rem`,
        "--padding-ratio": (G = b.value) == null ? void 0 : G["ratio-denominator"]
      };
    }), g = s(() => {
      const {
        horizontal: e,
        vertical: t
      } = d.value.sm;
      return {
        horizontal: e === "center",
        vertical: t === "center"
      };
    }), k = s(() => {
      var e;
      return !!((e = a.bannerGradient) != null && e.xs);
    });
    return E({
      cssVars: f,
      flexPosition: d,
      centerPositioningCorrection: g,
      computedBannerGradient: p,
      hasBannerGradient: k,
      getBannerGradient: x,
      computedBannerHeight: c
    }), (e, t) => (C(), M("div", {
      style: F(f.value),
      class: y(["banner", {
        "no-background": e.hasNoBackground
      }]),
      "data-ui": "banner"
    }, [H("div", {
      style: F(`background-color: ${e.backgroundColor}`),
      class: "banner__frame"
    }, [N(e.$slots, "background"), k.value ? (C(), M("div", D)) : w("", !0), H("div", {
      class: y(["banner__content-block", {
        "banner__content-block--corrected-horizontal": g.value.horizontal,
        "banner__content-block--corrected-vertical": g.value.vertical
      }])
    }, [N(e.$slots, "content")], 2)], 4)], 6));
  }
});
export {
  O as default
};
